import { useCallback } from 'react';
import { Button } from '@picsart/design-system/components/Button';
import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';
import { useTranslator } from '@picsart/rc/services/localization';

import { logout, deleteAccount } from '@/utils/user/authActions';
import useStyles from './styles';

interface SettingsActionsProps {
  isAuthorized: boolean;
}

const SettingsActions = ({ isAuthorized }: SettingsActionsProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  const handleLogout = useCallback(() => logout(), []);
  const handleDeleteAccount = useCallback(() => deleteAccount(), []);

  if (!isAuthorized) return null;

  return (
    <div className={classes.actions}>
      <Button
        dataTestId="genai-settings-log-out"
        variant="outlined"
        size="large"
        startIcon={IconLogout}
        isFullWidth
        onClick={handleLogout}
      >
        {translate('Log Out')}
      </Button>
      <InlineButton
        className={classes.deleteAccountButton}
        dataTestId="genai-settings-delete-account"
        size="small"
        alignment="center"
        isWithoutBorder
        isWithoutBackground
        onClick={handleDeleteAccount}
      >
        {translate('Delete account')}
      </InlineButton>
    </div>
  );
};

export default SettingsActions;
